module.exports = __webpack_public_path__ + "static/media/HeroSPD.d49c25ea.jpg";